<!--
    描述：模板管理
    时间：2022-07-01
    Created by 张卫华
-->
<template>
  <div class="w-table-layout"
       :class="{'w-table-page': searchObj.listType == 0}">
    <transition name="fade"
                mode="out-in">
      <!-- 列表 -->
      <div class="list-wrap w-table-content"
           ref="tableContent"
           key="list">
        <!--
                <vxe-table
                  ref="objTable"
                  row-id="id"
                  :height="tableObj.tableH"
                  :loading="tableObj.loading"
                  :data="tableObj.tableData"
                  :tree-config="{children: 'children'}"
                >
                -->
        <vxe-table ref="objTable"
                   border
                   highlight-hover-row
                   highlight-current-row
                   highlight-hover-column
                   highlight-current-column
                   row-id="id"
                   height="auto"
                   size="small"
                   :data="tableObj.data">
          <vxe-table-column field="docTemplateName"
                            header-align="center"
                            title="模板名称"
                            min-width="150">
          </vxe-table-column>
          <vxe-table-column field="updateDate"
                            header-align="center"
                            title="更新时间"
                            align="center"
                            width="165">
            <template v-slot="{ row }">
              {{timeStampToTime(row.updateTime)}}
            </template>
          </vxe-table-column>
          <vxe-table-column field="isFlag"
                            title="流程状态"
                            align="center"
                            show-overflow
                            width="120">
            <template v-slot="{ row }">
              <el-switch v-model="row.isFlag"
                         v-if="row.isFlag != null"
                         class="switch"
                         active-color="#2671cc"
                         inactive-color="#cccccc"
                         :active-value="1"
                         :inactive-value="0"
                         active-text="生效"
                         inactive-text="禁用"
                         disabled
                         @click.native.prevent="statusChange(row)">
              </el-switch>
            </template>
          </vxe-table-column>
          <vxe-table-column field="type"
                            title="操作"
                            align="center"
                            width="180">
            <template v-slot="{ row }">
              <el-button type="primary"
                         size="small"
                         round
                         plain
                         class="table-btn"
                         icon="el-icon-edit"
                         @click="doClick(row,'edit')">编辑
              </el-button>
              <el-button type="danger"
                         size="small"
                         round
                         plain
                         class="table-btn"
                         icon="el-icon-delete"
                         @click="doClick(row,'delete')">删除
              </el-button>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </transition>

    <!-- 底部分页 -->
    <div v-if="searchObj.listType==0"
         class="w-table-pager">
      <!-- :loading="loading" -->
      <vxe-pager :current-page="tableObj.currentPage"
                 :page-size="tableObj.pageSize"
                 :total="tableObj.total"
                 :layouts="['Total', 'PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes']"
                 align="center"
                 @page-change="handleCurrentChange"
                 class="footer-container mt5">
      </vxe-pager>
    </div>

    <!-- 新增、编辑等弹窗 -->
    <el-dialog :title="dialogObj.title"
               :visible.sync="dialogObj.visible"
               :width="dialogObj.width"
               :close-on-click-modal="false"
               center
               @closed="handleClose">

      <!-- 弹窗组件 -->
      <addTemplate v-if="dialogObj.visible"
                 ref="addTemplate"
                 @submit-success="submitSuccess"></addTemplate>

      <!-- footer 组件 -->
      <div slot="footer"
           class="dialog-footer text-center"
           v-if="dialogObj.type !== 'view'">
        <el-button size="small"
                   class="btn"
                   @click="dialogObj.visible = false">取 消</el-button>
        <el-button type="primary"
                   size="small"
                   class="btn btn-blue"
                   :loading="btnLoading"
                   @click="doSave">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 模板编辑弹窗 -->
    <el-dialog :title="editDialogObj.title"
               :visible.sync="editDialogObj.visible"
               :width="editDialogObj.width"
               :close-on-click-modal="false"
               center
               @closed="handleClose">
      <div v-if="editDialogObj.visible" style="width: 100%;height: 700px">
        <editTemplate v-if="editDialogObj.visible"
                      ref="editTemplate"
                      :docTemplateId="editDialogObj.docTemplateId"
                      @submit-success="submitSuccess"></editTemplate>

        <!-- footer 组件 -->
      </div>
      <!-- 弹窗组件 -->

      <div slot="footer"
           class="dialog-footer text-center"
           v-if="editDialogObj.type !== 'view'">
        <el-button size="small"
                   class="btn"
                   @click="editDialogObj.visible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as API from 'api/modules/es/es_template.js'
import addTemplate from './template_add_dialog'
import editTemplate from './template_edit_dialog'
import { timeStampToTime } from 'utils/tools.js'
export default {
  components: { addTemplate,editTemplate },
  data() {
    return {
      //查询
      searchObj: {

      },
      //列表对象
      tableObj: {
        loading: false,
        pageSize: 10,
        currentPage: 1,
        total: 0,
        tableH: 0,
        originTableData: [],
        data: [],
        pageList: [10, 20, 50, 100], // 显示条数数组
      },
      btnLoading: false,
      //新增本地模板弹窗
      dialogObj: {
        title: '',
        visible: false,
        width: '750px',
        mode: 'add',
      },

      //编辑模板弹窗
      editDialogObj: {
        title: '',
        visible: false,
        width: '1350px',
        mode: 'add',

        docTemplateId : '',

      },
    }
  },
  created() {
    this.getPageTableList()
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.tableObj.tableH = this.$refs.tableContent.offsetHeight
      }, 100)
    })
  },
  methods: {
    //分页：字典列表信息
    getPageTableList() {
      let that = this
      that.searchObj.listType = 0
      let param = Object.assign({}, this.searchObj)
      /*
      param.pageNum = this.tableObj.currentPage
      param.pageSize = this.tableObj.pageSize
       */
      param.current = this.tableObj.currentPage
      param.size = this.tableObj.pageSize
      API.getPageTableList(param).then((res) => {
        if (res.code == 0) {
          that.tableObj.data = res.data.records
          that.tableObj.total = parseInt(res.data.total)
        }
      })
    },

    //新增、修改、删除等操作按钮点击事件
    doClick(obj, type) {
      let that = this
      if(type == 'addLocalTemplate') {
        this.dialogObj.title = "新增本地模板"
        this.dialogObj.visible = true
      } else if(type == 'edit') {
        this.editDialogObj.docTemplateId = obj.docTemplateId
        this.editDialogObj.title = "编辑模板"
        this.editDialogObj.visible = true
      } else if(type == 'delete') {
        this.deleteById(obj)
      }
    },

    // 确认删除弹窗
    deleteById(obj) {
      let that = this
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let param = { docTemplateId: obj.docTemplateId }
        API.deleteByDocTemplateId(param).then(res=>{
          this.getPageTableList()
        })
      })
    },

    // 切换显示条数
    handleSizeChange(val) {
      this.tableObj.pageSize = val
      this.getTablePageList()
    },

    // 切换当前页码
    handleCurrentChange({ currentPage, pageSize }) {
      this.tableObj.currentPage = currentPage
      this.tableObj.pageSize = pageSize
      this.getTablePageList()
    },

    // 弹窗确认保存
    doSave() {
      this.$refs.addTemplate.doSave()
    },
    submitSuccess(){
      this.dialogObj.visible = false
      this.getPageTableList()
    },

    handleClose() {},

    // 状态改变
    statusChange(row) {
      let _flag = row.isFlag == 0 ? 1 : 0
      this.$confirm('是否确认改变该码表的状态', '提示', {
        confirmButtonText: '确 认',
        cancelButtonText: '取 消',
        type: 'warning',
      })
          .then(() => {

          })
          .catch(() => {
            this.$message.info('操作取消！')
          })
    },
    timeStampToTime(val){
      return timeStampToTime(val)
    },
  },
  computed: {
    ...mapState('menu', {
      roleBtns: (state) => state.roleBtns,
    }),
  },
}
</script>

<style scoped lang="less">
.w-table-pager {
  .footer-container {
    height: 100%;
  }
}
.switch {
  /deep/ .el-switch__label--right span {
    margin-left: -15px;
  }
  /deep/ .el-switch__label {
    cursor: pointer !important;
  }
}
.el-switch.is-disabled {
  opacity: 1;
}
</style>